import { Navigate, useParams } from "react-router-dom";
import { studioWorkspacePath } from "@/utils/studioRoute";

// The Workspaces pages are gone (TTTL-179): drafts live on the Pipelines
// page and a saved workspace opens in the Studio. Old links and bookmarks
// still land somewhere useful.
export function LegacyWorkspaceRedirect() {
  const { id } = useParams<{ id?: string }>();
  const to = id ? studioWorkspacePath(id) : "/pipelines?tab=drafts";
  return <Navigate to={to} replace />;
}
